<template>
  <div>
    <!-- <el-button @click="aaa">切换 {{ step }}</el-button> -->
    <div class="left-arrow" @click="handleBack" v-if="step > 0">
      <i class="el-icon-arrow-left"></i>
    </div>
    <template v-if="step === 0">
      <div  class="dialog-content step-diolog">
        <div class="dialog-title">{{ $t('preApprovalLogin.salesPlatform') }}</div>
        <div class="dialog-des">
          {{ $t('preApprovalLogin.description4') }}
        </div>
        <div class="sel-platform-wrap">
          <div v-for="item in items" :key="item.id" class="sel-platform-sty" :class="{ 'active-item': item.id === activeId,'select-gary': item.id > 1 && item.id < 5 }"
            @click="handleSelectPlatform(item)">
            <img :src="item.backgroundImage" />
            <!-- <div class="sel-platform-checked">
              <i class="el-icon-check"></i>
            </div> -->
            <i class="lls-icon-success"></i>
          </div>
        </div>
  
      </div>
      <lls-button type="primary" @click="handleNext" class="next-btn">{{ $t('preApprovalLogin.next') }}</lls-button>
    </template>
    <!-- chrome-->
    <template v-if="activeId === 0">
      <template v-if="step === 1">
        <div class="dialog-content step-diolog">
          <div class="dialog-title">{{ $t('preApprovalLogin.marketplace') }}</div>
          <div class="dialog-des">
            {{ $t('preApprovalLogin.description4') }}
          </div>
    
          <div class="sel-marketplace-wrap">
            <div v-for="region in regionList" class="wrap">
              <div class="region-name">{{ curLang === 'zh' ? region.regionCn : region.regionEn }}</div>
              <div class="country-box">
    
                <div v-for="item in region.regions" class="region-box" @click="check(item)"
                  :class="{ 'choice-active': activeRegionId === item.marketplaceCode }">
                  <img :src="item.fileLink" alt="Image">
                  <!-- <img src="./America 1@2x.png" alt="Image"> -->
                  <span>
                    {{ curLang === 'zh' ? item.marketplaceCn : item.marketplaceCode }}
                  </span>
    
                </div>
              </div>
            </div>
          </div>
    
        </div>
        <lls-button 
          type="primary"
          @click="handleMarketplaceNextStep" 
          :disabled="!activeRegionId" 
            class="next-btn">
          {{ $t('preApprovalLogin.next') }}
        </lls-button>
      </template>

      <template v-else-if="step === 2">

        <div  class="dialog-content dialog step-diolog">
          <div class="bg-img"> </div>
          <div class="count-down">{{ count }}S</div>
          <div class="font-sty">
            <template v-if="curLang === 'zh'">
              您已<a class="copy-link" @click="copyTextToClipboard(copyLink)">复制链接</a>，<span class="bold">请打开常用浏览器</span>，<span class="bold">粘贴访问该链接</span>，<span class="bold">完成授权</span><br/>
              完成授权后，该页面会自动刷新
            </template>
            <template v-else>
              You have <a class="copy-link" @click="copyTextToClipboard(copyLink)">copied the link</a>, please <span class="bold">open your browser and</span> <br/>
              <span class="bold">paste</span>. After completing the authorization, this page will be <br/>
              automatically refreshed
            </template>
          </div>
    
        </div>
        <lls-button type="primary" @click="$emit('close')" class="next-btn">{{ $t('preApprovalLogin.done') }}</lls-button>
      </template>

      <template v-else-if="step === 3">
        <div class="success-status step-diolog">
          <div class="icon"></div>
          <div class="icon-txt">{{ $t('preApprovalLogin.syncSuccess') }}</div>
        </div>
        <lls-button type="primary" @click="$emit('close')" class="next-btn">{{ $t('preApprovalLogin.done') }}</lls-button>
      </template>

    </template>

    <!-- JDVC -->
    <template v-if="step === 1 && activeId === 1">
      <div class="step-diolog download-app-wrap">
        <div class="check-icon-wrap">
          <i class="el-icon-check"></i>
        </div>
        <div class="dialog-title">{{ $t('preApprovalLogin.continueTip') }}</div>
        <div class="dialog-des des-newline" style="margin-top: 12px;">
          <span>{{ $t('preApprovalLogin.continueTip2') }} </span>
          <!-- <span>open unsuccessfully, please click here to retry.</span> -->
        </div>
  
        <div class="link-top"></div>
        <div class="download-app">
          <span class="dialog-des" style="font-size: 14px;">
            {{ $t('preApprovalLogin.continueTip3') }}
            <!-- How it Works?
            Installed already, open App to proceed
            Need Support? -->
          </span>
          <div class="down-app-wrap">
            <div class="plug-app-wrap"></div>
            {{ $t('preApprovalLogin.appName') }}
            <div class="chrome-wrap"></div>
            <!-- <a :href="zipFileUrl" download="example.zip">123
              </a> -->
              <i class="lls-icon-download" @click="downloadTemplate"></i>
              <!-- {{ zipFileUrl }} -->
          </div>
          <div class="contact" @click="openApp">{{ $t('preApprovalLogin.continueTip4') }}</div>
        </div>
      </div>
      <lls-button type="primary"  @click="$emit('refreshData'); $emit('close')" class="next-btn">{{ $t('preApprovalLogin.continueTip5') }}</lls-button>
      <div class="contact" style="margin-top: 17px;" @click="openUrl">{{ $t('preApprovalLogin.continueTip6') }}</div>
    </template>


    <!-- chrome-->
    <!-- <div slot="footer">
    </div> -->
    
    <!-- JDVC -->
    <!-- <div slot="footer">
      <lls-button type="primary" @click="handleNextStep" class="next-btn">Next</lls-button>
      <div v-if="activeId === 1 && step === 1" class="contact" style="margin-top: 17px;" @click="openUrl">Need Support?</div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'dialog',
  
  props: {
    initStep: {
      type: [Number],
      default: 0
    }
  },
  data() {
    return {
      zipFileUrl: '/dist.zip',
      // chrome: require('@/static/projectImg/login/chrome.png'),
      plugApp: require('@/static/projectImg/login/plug-app.png'),
      step: 0,
      activeId: 0,
      selectPlatformDialog: false,
      items: [{
        id: 0,
        backgroundImage: require('@/static/projectImg/login/amazon.png'),
      }, {
        id: 1,
        backgroundImage: require('@/static/projectImg/login/jd.svg'),
      }, {
        id: 2,
        backgroundImage: require('@/static/projectImg/login/tiktok.svg'),
      }, {
        id: 3,
        backgroundImage: require('@/static/projectImg/login/temu.svg'),
      }, {
        id: 4,
        backgroundImage: require('@/static/projectImg/login/shopee.svg'),
      },{
        id: 5,
        backgroundImage: require('@/static/projectImg/login/others.png'),
      }],
      count: 60,
      timeKey: null,
      activeRegionId: '',
      regionList: [],
      curLang: localStorage.getItem("locale"),  // zh / en
      copyLink: ''
    }
  },
  created() {
    this.treeDataList();
    if (this.initStep) {
      this.step = this.initStep
    }
  },
  destroyed() {
    clearInterval(this.timeKey)
  },
  methods: {
    openApp () {
      const key = 'data.fetch.plugin.install.video.url'
      this.$API.system.getWebsiteUrl([key]).then(({ data }) => {
        this.url = data.data[key]
        window.open(this.url, '_blank')
      })
    },
    downloadTemplate() {
      // 跳转到官网插件 changelog 页面
      let env
      let localUrl = location.href
      if (localUrl.indexOf("qhhrly") > -1) {
        env = 'qa' //测试环境
      } else if((localUrl.indexOf('hrlyit') > -1)) {
        env = 'uat'; //uat环境
      } else if((localUrl.indexOf('linklogis.com') > -1)) {
        env = 'production' //生产环境
      } else if(localUrl.indexOf("localhost") > -1) {
        env = 'localhost'
      } else {
        env = 'default'
      }
      const urlObj = {
        qa: 'https://international.qhhrly.cn',
        uat: 'https://international.hrlyit.com',
        production: 'https://www.linklogis.com.hk',
        default:'https://www.linklogis.com.hk',
        localhost:'http://localhost:8080'
      }
      window.location.href = `${urlObj[env]}/#/docs/9.2-changelog`
      // // 获取当前网页的域名
      // const domainName = window.location.hostname;
      // let fileUrl = ''
      // // uat 环境
      // if (domainName.indexOf('hrlyit') > -1) { 
      //   // 使用相对路径
      //   fileUrl = '/dist.zip';
      // } else { 
      //   // 正式
      //   fileUrl = '/distProd.zip';
      // }
      
      // // 创建一个隐藏的a标签
      // const link = document.createElement('a');
      // link.href = fileUrl;
      // link.download = 'LLSFinancingAssistant.zip';  // 设置下载文件名
      
      // // 将a标签添加到DOM并触发点击事件
      // document.body.appendChild(link);
      // link.click();
      
      // // 移除a标签
      // document.body.removeChild(link);
    },
    handleDownload({ url }) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(a.href)
      document.body.removeChild(a)
    },
    openUrl(){
      window.open('https://www.linklogis.com.hk/#/Contact', '_blank')
    },
    handleBack () {

      if (this.activeId === 0 && this.step === 1) {
        clearInterval(this.timeKey)
      }
      this.step--
    },
    handleNext() {
      // 亚马逊
      if (this.step === 0 && this.activeId === 0) {
        this.step++ 
      } else if (this.step === 0 && this.activeId === 5) {
        // others
        this.$API.system.bindEnterpriseAccess({
          type: 'Others',
          marketplace: '',
          source: "SELF_REGISTRATION" // 绑定店铺来源
        }).then(res=>{
          this.$emit('refreshData')
          this.$emit('close')
        })
        
      } else {
        // 京东
        this.$API.system.bindEnterpriseAccess({
          type: 'jdvc',
          marketplace: '',
          source: "SELF_REGISTRATION" // 绑定店铺来源
        }).then(({data}) => {
          // 清空已选
          this.step++
        })

      }
    },
    // 授权
    handleMarketplaceNextStep () {
      // const data = await this.$API.system.listMarketplaceRegion({ sceneType: 'AMAZON' })
      // if (!this.activeRegionId) {
      //   this.$message.wra
      // }
      this.$API.system.bindEnterpriseAccess({
        type: this.activeId === 0 ? 'amazon' : 'jdvc',
        marketplace: this.activeRegionId,
        source: "SELF_REGISTRATION" // 绑定店铺来源
      }).then(({data}) => {
        // 清空已选
        // this.activeId = ''
        this.step++  // 2
        this.startWait(data.data)
        // this.$router.push({ 
        //   name: "waitAuthorizate" , 
        //   params: { 
        //     sceneState: data.sceneState,
        //     link: data.link
        //    }
        // })
        // this.treeDataList();
        // this.$message.success(this.$t("permissionSetting.editSuccess"));
      }).finally(() => {
      });
    },
    
    async checkStatus (sceneState) {
      const params = {
        sceneState: sceneState
      }
      const { data } = await  this.$API.system.queryAccessStatus(params)
      if (!data) clearInterval(this.timeKey)
      return data
    },
    async copyTextToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message({
        message: this.$t('preApprovalLogin.copyLink'),
        type: "success",
        customClass: 'zZindex'
      });
      } catch (err) {
      }
    },
    async treeDataList() {
      const data = await this.$API.system.listMarketplaceRegion({ sceneType: 'AMAZON' })
      
      this.regionList = data.data.data || []; // 权限菜单
    },
    check(item) {
      this.activeRegionId = item.marketplaceCode
    },
 
    handleSelectPlatform(item) {
      if (item.id > 1 && item.id < 5 ) return
      this.activeId = item.id
    },
    dialogClose() {
      clearInterval(this.timeKey)
    },
    startWait(apiData) {
      this.timeKey = setInterval(async () => {
        const {data} = await this.checkStatus(apiData.sceneState)
        // 已经授权，跳转回去
        if (data.authStatus === '2') {
          clearInterval(this.timeKey)
          this.step = 3 // 跳转到成功状态
          // this.dialogVisible = false
          this.$emit('refreshData') //刷新列表
        }

        if (this.count > 0) {
          this.count--
        } else {
          this.count = 60
        }
      }, 1000);
      this.copyLink = apiData.link
      this.copyTextToClipboard(apiData.link)
    },
  }




}
</script>

<style lang="scss" scoped>
.copy-link {
  cursor: pointer;
  color: #3e8cfa;
  &:hover {
    text-decoration: underline #3e8cfa; 
  }
}
.el-icon-plus {
  font-size: 12px;
  font-weight: 600;
}

.dialog-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 24.51px;
  color: #4E78B1;
}

.dialog-des {
  color: #7A7A7A;
  margin-top: 8px;
  font-weight: 400;
  font-size: 14px;
}

::v-deep .select-platform-dialog {
  width: 694px !important;
  // margin-top: calc((100vh - 300px) / 2) !important;
  padding: 28px 54px 14px;
}

::v-deep .next-btn {
  width: 100%;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  line-height: 14px;
  background: linear-gradient(75.35deg, #5A9CF8 16.14%, #90BEFD 100%);
  margin-top: 42px;

}

.sel-platform-sty {
  width: 105px;
  height: 74px;
  padding: 16px 16px 17px 16px;
  border-radius: 15px;
  box-shadow: 0px 0px 10px 0px #63749233;
  background-size: contain;
  cursor: pointer;
  position: relative;

  &:hover {
    display: absolute;
  }
}
.lls-icon-success {
  position: absolute;
  right: -5px;
  bottom: -3px;
  display: none;
  color: #06d6a0;
}
.active-item .lls-icon-success {
  display: block;
}
// .sel-platform-checked {
//   width: 16px;
//   height: 16px;
//   background: #39C146;
//   // display: none;
//   position: absolute;
//   border-radius: 50%;
//   font-size: 11px;
//   color: #fff;
//   text-align: center;
//   right: -5px;
//   bottom: -3px;
//   display: none;
// }

.sel-platform-wrap {
  margin: 22px 0 12px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 104px);
  gap: 29px 19px;

  img {
    width: 73px;
    height: 41px;
  }
}

.sel-marketplace-wrap {
  margin: 22px 0 12px;
}

// .active-item .sel-platform-checked {
//   display: block;
// }

.bg-img {
  width: 197px;
  height: 160px;
  background: url('~@/static/projectImg/login/countdown.png') no-repeat;
  background-size: contain;
  margin-top: 64px;
}

.font-sty {
  font-size: 14px;
  color: #333333;
  text-align: center;
  line-height: 24px;
}

.dialog {
  height: 380px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.count-down {
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: #2e5a99;
  line-height: 24px;
  margin: 16px 0
}

.bold {
  font-weight: 800
}

.success-status {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.icon {
  width: 50px;
  height: 50px;
  background: url('~@/static/projectImg/login/success.svg') no-repeat center center;
  margin-top: 15%;
  background-size: contain;
}

.icon-txt {
  color: #00A843;
  margin: 31px 0 114px;
  font-size: 16px;
  font-weight: 700;
}

.wrap {
  display: flex;
  margin-bottom: 20px;
  // align-items: center;
}

.region-name {
  flex: 0 0 100px;
  font-size: 14px;
  color: #333;
}

.country-box {
  white-space: normal;
  display: flex;
  gap: 12px 16px;
  flex-wrap: wrap;
}

.region-box {
  width: 120px;
  height: 32px;
  line-height: 16px;
  padding: 0 8px;
  border: 1px solid #c2c6cc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333333;
  display: flex;
  gap: 8px;
  align-items: center;

  &:hover {
    border: 1px solid #3e8cfa;
    cursor: pointer;
  }

  img {
    width: 24px;
    height: 24px;
  }
}

.choice-active {
  border: 1px solid #3e8cfa;
}

.check-icon-wrap {
  width: 72px;
  height: 72px;
  background: #A28D231F;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  margin-bottom: 20px;

  .el-icon-check {
    border-radius: 50%;
    width: 39px;
    height: 39px;
    background: #A27C23;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
  }
}

.download-app-wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.des-newline {
  display: flex;
  align-items: center;
  flex-direction: column;
}

/*中间的过度的横线*/
.link-top {
  width: 492px;
  height: 1px;
  border-top: solid #EDEDED 1px;
  margin: 31px 0;
}

.download-app {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 495px;
  height: 150px;
  border: 1px solid #C4C4C440;
  border-radius: 5px;
  padding: 14px 0 21px;
}

.contact {
  font-size: 12px;
  color: #7FB3FC;
  cursor: pointer;
  text-align: center;
  &:hover {
    text-decoration: underline;
  }
}

.down-app-wrap {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 255px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 1.49px 2.31px 0px #00000007;
  margin: 17px 0 11px;
}

.plug-app-wrap {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: url('~@/static/projectImg/login/plug-app.png') no-repeat center center #D9D9D9;
  background-size: 22px;

}

.chrome-wrap {
  width: 32px;
  height: 32px;
  // border-radius: 50%;
  background: url('~@/static/projectImg/login/chrome.svg') no-repeat center center;
  background-size: 22px;

}
.left-arrow {
  position: absolute;
  height: 31px;
  width: 31px;
  cursor: pointer;
  border: 1px solid #E8ECF4;
  text-align: center;
  line-height: 31px;
  border-radius: 10px;
  top: 17px;
  left: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: #f7f7f7;
  }
}
.el-icon-download {
  color: #7A7A7A;
  font-size: 20px;
}
.lls-icon-download {
  cursor: pointer;
  font-size: 16px;
}
.select-gary {
  box-shadow: none;
  border: 1px solid #f6f6f6;
  cursor: not-allowed;
}
 
</style>